import React, { Component } from "react";
import OrgChartNode from "./OrgChartNode";

// Inline styles for renderToStaticMarkup compatibility (MUI v6)
const styles = {
  stack: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    gap: "16px",
  },
  textOverflow: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    padding: "0 16px",
    whiteSpace: "nowrap" as const,
    width: "100%",
    boxSizing: "border-box" as const,
  },
};

export default class OrgChartCompanyNode extends Component<any, any> {
  static defaultProps = {
    type: "company",
  };

  constructor(props: any) {
    super(props);

    this.state = {};
  }

  render() {
    const { organization, data, inHighlightPath } = this.props;

    return (
      <OrgChartNode
        wrapperChildren={[
          <div
            key="0"
            style={{
              position: "absolute",
              background: inHighlightPath
                ? "var(--neon-blue-nb-500)"
                : "var(--neon-blue-nb-100)",
              height: "100%",
              top: "0",
              width: inHighlightPath ? "2px" : "1px",
              transform: inHighlightPath
                ? "translate(129.0px, 0px)"
                : "translate(129.5px, 0px)",
              zIndex: -1,
            }}
          ></div>,
        ]}
        height={64}
        alignItems="center"
        arrowhead={false}
        sx={{
          fontWeight: 600,
          backgroundColor: "var(--prussian-blue-pb-600) !important",
          borderColor: "var(--prussian-blue-pb-600) !important",
          color: "white",
        }}
      >
        <div style={styles.stack}>
          <div className="klayo-textoverflow" style={styles.textOverflow}>
            {organization ? organization.name : "Company"}
          </div>
        </div>
      </OrgChartNode>
    );
  }
}
